import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  HostBinding
} from '@angular/core';

@Component({
  selector: 'awair-backdrop',
  templateUrl: './backdrop.component.html',
  styleUrls: ['./backdrop.component.scss']
})

export class BackdropComponent implements OnChanges, OnInit {
  @HostBinding('style.position') hostPosition: string = 'absolute';
  @HostBinding('style.background-color') hostBackgroundColor: string = '#212528';
  @HostBinding('style.opacity') hostOpactity: number = 0;
  @HostBinding('style.top') hostTop: number = 0;
  @HostBinding('style.bottom') hostBottom: number = 0;
  @HostBinding('style.right') hostRight: number = 0;
  @HostBinding('style.left') hostLeft: number = 0;
  @HostBinding('style.width') hostWidth: string = '100%';
  @HostBinding('style.height') hostHeight: string = '100%';
  @HostBinding('style.z-index') hostZIndex: number = 500;
  @HostBinding('style.transition') transition: string = '2s ease opacity';

  @Input() zIndex: number;
  @Input() height: string;
  @Input() backgroundColor: string;
  @Input() opacity: number;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    for (const propname in changes) {
      if (propname === 'zIndex') {
        this.hostZIndex = this.zIndex;
      } else if (propname === 'height') {
        this.hostHeight = this.height;
      } else if (propname === 'backgroundColor') {
        this.hostBackgroundColor = this.backgroundColor;
      } else if (propname === 'opacity') {
        this.hostOpactity = this.opacity;
      }
    }
  }

  ngOnInit() {
  }
}
